import axios from "axios";

const BASE_URL = process.env.REACT_APP_AGENT_API_URL || "https://agent.causalfunnels.com/api/agent";

export const agentAPI = {
  getRecommendations: (collectionName) => {
    return axios.get(`${BASE_URL}/recommendations/${collectionName}`);
  },

  ask: (collectionName, question, currentPage) => {
    return axios.post(`${BASE_URL}/ask`, { collectionName, question, currentPage });
  },

  sendFeedback: (collectionName, recommendationId, action) => {
    return axios.post(`${BASE_URL}/feedback`, { collectionName, recommendationId, action });
  },

  getTips: (collectionName, moduleName) => {
    return axios.get(`${BASE_URL}/tips/${collectionName}/${moduleName}`);
  },

  clearConversation: (collectionName) => {
    return axios.post(`${BASE_URL}/clear-conversation`, { collectionName });
  },

  getQueueStatus: () => {
    return axios.get(`${BASE_URL}/queue-status`);
  },

  checkEnabled: (collectionName) => {
    return axios.get(`${BASE_URL}/enabled/${collectionName}`);
  },

  toggleAgent: (collectionName, enabled, adminEmail) => {
    return axios.post(`${BASE_URL}/toggle`, { collectionName, enabled, adminEmail });
  },

  // Streaming helpers
  streamRecommendations: (collectionName) => {
    return `${BASE_URL}/recommendations/stream/${collectionName}`;
  },

  streamAsk: () => {
    return `${BASE_URL}/ask/stream`;
  },
};

// SSE stream consumer helper
export function consumeSSEStream(url, options = {}) {
  const { method = "GET", body = null, onProgress, onResult, onError } = options;

  return new Promise((resolve, reject) => {
    if (method === "GET") {
      const eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "progress" && onProgress) {
            onProgress(data.step, data.message);
          } else if (data.type === "result" && onResult) {
            onResult(data.data);
            eventSource.close();
            resolve(data.data);
          } else if (data.type === "error" && onError) {
            onError(data.error);
            eventSource.close();
            reject(new Error(data.error));
          }
        } catch (e) {
          console.error("SSE parse error:", e);
        }
      };

      eventSource.onerror = (err) => {
        eventSource.close();
        if (onError) onError("Connection lost");
        reject(err);
      };

      return eventSource;
    } else {
      // POST requests can't use EventSource, use fetch with ReadableStream
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then((response) => {
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = "";

          function read() {
            reader.read().then(({ done, value }) => {
              if (done) return;
              buffer += decoder.decode(value, { stream: true });

              // Parse SSE events from buffer
              const lines = buffer.split("\n\n");
              buffer = lines.pop() || ""; // Keep incomplete chunk

              for (const line of lines) {
                const dataLine = line.replace(/^data: /, "").trim();
                if (!dataLine) continue;
                try {
                  const data = JSON.parse(dataLine);
                  if (data.type === "progress" && onProgress) {
                    onProgress(data.step, data.message);
                  } else if (data.type === "result") {
                    if (onResult) onResult(data.data);
                    resolve(data.data);
                  } else if (data.type === "error") {
                    if (onError) onError(data.error);
                    reject(new Error(data.error));
                  }
                } catch (e) {
                  console.error("SSE parse error:", e);
                }
              }
              read();
            });
          }
          read();
        })
        .catch((err) => {
          if (onError) onError(err.message);
          reject(err);
        });
    }
  });
}
